export function formatEnum(str) {
  return str.replace(/(?!^)([A-Z])/g, ' $1');
}